export default __webpack_public_path__ + "static/media/google_play_en.5e61c7ba.png";